module.exports = __webpack_public_path__ + "static/3-a9b905d4db8c899abfb0a4c30d9ff375.jpg";